import React from "react";
//outsource
import { Button, DatePicker, message } from "antd";

//components

const DialogWeekFrom = ({ to, from, setFrom, onChange, disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION -----------------------
  const handleChange = (time) => {
    if (to && time > to) {
      message.warning(
        "The start time of work is later than the end time of work."
      );
    } else {
      console.log(time);
      setFrom(time);
      onChange("workAt", time);
    }
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <DatePicker
      placeholder="From Time"
      value={from}
      picker="time"
      onChange={handleChange}
      allowClear={false}
      format="hh:mm A"
      disabled={disabled}
      getPopupContainer={(trigger) => trigger.parentElement}
      dropdownClassName="time-picker"
      onSelect={handleChange}
    />
  );
};

export default DialogWeekFrom;
